import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import { ReactComponent as TShirt } from '../../statics/images/t-shirt.svg';

//import { ColorPicker, ColorButton, ColorBox, ColorInput } from 'mui-color';

function TshirtColorSelector({setColor}) {
    const classes = useStyles();

    const predefinedColors = ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF',  '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#55aa55','#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'];

    return (
        <div className={classes.container}>
            <Grid container justify="center" >
                {
                    predefinedColors.map((color, index) => {
                        return (
                            <TShirt key={index} className={classes.tShirt} fill={color} stroke="black" onClick={()=>{setColor(color)}} ></TShirt>
                        )
                    })
                }
            </Grid>
        </div>
    );
}

export default TshirtColorSelector;

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        margin: "20px",

    },
    tShirt: {
        marginLeft: "2px",
        marginRight: "2px",
        width: '45px',
    }
}));